export const useEmbedded = () => {
  const params = new URLSearchParams(window.location.search)
  const embedded =
    !!params.get("embed") && window.location.pathname === "/calendar"
  return {
    embedded,
  }
}
